// Fontawesome 5
import './shared/font-awesome';

import WalletRouting from './Wallet.routes';

const WalletModule = angular.module('WalletModule', []);

WalletModule.config(WalletRouting);

export default WalletModule;